<template>
  <div
    class="pagoda-drop-down-item"
    :class="{
      'pagoda-drop-down-item--disabled': disabled
    }"
    @click="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DropDownItem',
  props: {
    disabled: Boolean
  },
  methods: {
    handleClick(e) {
      if (this.disabled) {
        e.stopPropagation()
      } else {
        this.$emit('click', e)
      }
    }
  }
}
</script>
